import { render, staticRenderFns } from "./approve.vue?vue&type=template&id=cbc2cc5c&"
import script from "./approve.vue?vue&type=script&scoped=true&lang=js&"
export * from "./approve.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./approve.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports